import { css } from '@emotion/core';
import { Theme, normalText, titleText } from 'features/Theme';

const styles = {
  pageTitleText: (theme: Theme) => css`
    ${titleText(theme)}
    text-align: center;
  `,
  normalText: (theme: Theme) => css`
    ${normalText(theme)}
    text-align: center;
  `,

  imageContainer: (theme: Theme) => css`
    display: flex;
    margin: 0 auto;
    width: ${theme.mui.spacing(25)}px;
    height: ${theme.mui.spacing(40)}px;
    align-items: center;
    justify-content: center;
  `,

  cardImage: (theme: Theme) => css`
    width: 100%;
    display: block;
  `,
};

export default styles;
